<template>
	<div class="certificate-list">
		<b-card header-tag="header" class="hidden-print" footer-tag="footer">
			<div slot="header" class="top-card">
				<span>
					<h5 v-if="true">{{$t('sidebar.sales.title')}}</h5>
					<!--					<h5 v-else>Z отчеты</h5>-->
				</span>
				<b-link @click="openCreate('create')"
						class="card-header-action btn-setting"
						style="font-size: 15px"
						v-if="departmentSaleType === 'WHOLE' && $can('create', 'sale')"
				>
					<i class="fa fa-plus-circle"></i>
				</b-link>
				<!--<b-form-radio-group
					id="btn-radios-2"
					v-model="selected"
					:options="options"
					buttons
					button-variant="outline-primary"
					size="sm"
					name="radio-btn-outline"
				></b-form-radio-group>-->
			</div>


			<transition name="slide" mode="out-in">
				<div class="filter-frame">
					<b-row class="my-1">
						<b-col sm="3">
							<!-- <label for="fromDate">
								{{$t('certificate.fromDate')}}
							</label> -->
							<b-input-group size="sm" class="mb-3">
								<date-picker v-model="fromDate" lang="ru" :placeholder="$t('certificate.fromDate')"
											 valueType="format"
											 format="DD-MM-YYYY"></date-picker>
							</b-input-group>

						</b-col>
						<b-col sm="3">
							<!-- <label for="toDate">
								{{$t('certificate.toDate')}}
							</label> -->
							<b-input-group size="sm" class="mb-3">
								<date-picker v-model="toDate" lang="ru" :placeholder="$t('certificate.toDate')"
											 valueType="format"
											 format="DD-MM-YYYY"></date-picker>
							</b-input-group>
						</b-col>
						<b-col sm="3">
							<!-- <label for="input-small">
								{{$t('pricing.department')}}
							</label> -->
							<multiselect
								v-model="selectedDepartment"
								v-if="isSales"
								:options="getDepartmentsLocal()"
								:multiple="true"
								:group-select="true"
								track-by="id"
								label="name"
								:placeholder="$t('pricing.department')"
								:show-labels="false"
								:allow-empty="true"
								class="multiselect-pricing"
							>
								<span
									slot="noResult">No elements found.</span>
							</multiselect>
							<multiselect
								v-model="zReportDep"
								v-else
								:options="getDepartmentsLocal()"
								:multiple="false"
								:group-select="true"
								track-by="id"
								label="name"
								:placeholder="$t('pricing.department')"
								:show-labels="false"
								:allow-empty="true"
								class="multiselect-pricing"
							>
								<span
									slot="noResult">No elements found.</span>
							</multiselect>
						</b-col>
						<b-col sm="3" v-if="isSales">
							<!-- <label for="input-small">
								<span>
									{{$t('sale.saleNumber')}}
								</span>
							</label> -->
							<b-input-group
								size="sm"
								class="mb-3"
							>
								<b-form-input
									:placeholder="$t('sale.saleNumber')"
									v-model="saleNumber"
									type="text"
								>
								</b-form-input>
							</b-input-group>
						</b-col>
						<b-col sm="3" v-if="!isCashier && isSales">
							<!-- <label for="input-small">
								контрагент
							</label> -->
							<multiselect
								v-model="contrAgent"
								:options="contragents"
								track-by="id"
								:multiple="true"
								:group-select="true"
								:show-labels="false"
								:allow-empty="true"
								label="fullName"
								placeholder="-- Выберите контрагента --"
								class="multiselect-pricing"
							>
							</multiselect>
						</b-col>
						<b-col sm="3" v-if="isSales">
							<!-- <label for="input-small">
								{{$t('promo-to-product.status')}}
							</label> -->
							<b-form-select
								v-model="checkStatus"
							>
							<option value="PAID">{{$t('sidebar.sales.ready')}}</option>
							<option value="QARZGA">{{$t('xAtchot.debt')}}</option>
							<option value="QAYTARISH">{{$t('pos.return')}}</option>
							<!-- <option value="HOMIYLIK">{{$t('pos.sponsorship')}}</option> -->
								<template slot="first">
									<option :value="null">-- {{$t('promo-to-product.status')}} --</option>
								</template>
							</b-form-select>
						</b-col>
						<b-col sm="3"
							   class="d-flex justify-content-end align-items-end"
							   :class="isSales ? 'pb-2' : 'pb-3'"
						>
							<b-button variant="dark" @click="search">
							<span>
								<i class="fa fa-search"></i>
								{{$t('certificate.search')}}
							</span>
							</b-button>
						</b-col>
					</b-row>
					<!--<div class="search_btn" v-if="isSales">
						<b-button variant="dark" @click="search">
							<span>
								<i class="fa fa-search"></i>
								{{$t('certificate.search')}}
							</span>
						</b-button>
					</div>-->
				</div>
			</transition>
			<div class="table-responsive table-wrapper">
				<b-table class="generalTableClass "
						 hover="hover"
						 striped="striped"
						 bordered="bordered"
						 small="small"
						 fixed="fixed"
						 :items="getTableItems"
						 responsive
						 :fields="computedFields"
						 show-empty

				>
					<template slot="empty" slot-scope="scope">
						<h4>{{ $t('empty') }}</h4>
					</template>

					<template slot="id" slot-scope="data">
						<strong>{{ data.index + 1}}</strong>
					</template>
					<template slot="status" slot-scope="data">
						<strong v-if="checkStatus == 'QAYTARISH'">
							{{ $t('pos.return') }}
						</strong>
						<template v-else>
							<template v-if="data.item.status === 'READY' && calculatePaidSum(data.item.payments) > 0">
								<strong>{{ $t('sidebar.sales.ready') }}</strong>
								<br>
								<span>{{ calculatePaidSum(data.item.payments) | currency({
									symbol:
									returnCurrencyNameForDep(data.item.shopId), fractionCount: 2, symbolPosition: 'back'
									}) }}</span> <br v-if="hasDeptPayment(data.item.payments)">
							</template>
							<template v-if="hasDeptPayment(data.item.payments)">
								<strong>
									{{$t('xAtchot.debt')}}:
								</strong>
								<br>
								<span>{{ data.item.payments.find(el => el.paymentTypeCode == 'QARZGA').value | currency({
									symbol:
									returnCurrencyNameForDep(data.item.shopId), fractionCount: 2, symbolPosition: 'back'
									}) }}
								</span>
							</template>
						</template>

					</template>

					<template slot="itemsCount" slot-scope="data">
						<strong v-if="checkStatus == 'QAYTARISH'">{{ data.item.totalCount }}</strong>
						<strong v-else>{{ saleItemsCount(data.item.saleItems) }}</strong>
					</template>

					<template slot="zReportStatus" slot-scope="data">
						<b-badge variant="success" v-if="data.item.open" style="padding: 5px 10px;">Открыть</b-badge>
						<b-badge variant="info" v-else style="padding: 5px 10px;">Закрыто</b-badge>
					</template>

					<template slot="amountOfPaymentUzs" slot-scope="data">
						{{ data.item.amountOfPaymentUzs | currency({
						symbol:
						returnCurrencyNameForDep(data.item), fractionCount: 2, symbolPosition: 'back'
						}) }}
					</template>

					<template slot="amountOfAfterPromoUzs" slot-scope="data">
						<strong>{{ data.item.amountOfAfterPromoUzs | currency({
							symbol:
							returnCurrencyNameForDep(data.item), fractionCount: 2, symbolPosition: 'back'
							}) }}</strong>
					</template>
					<template slot="actions" slot-scope="data">
						<b-link @click.prevent="editBtn(data, 'forModal')">
							<i class="fa fa-eye editBtn"></i>
						</b-link>
						<b-link @click.prevent="editBtn(data, 'forDocument')"
						>
							<i class="fa fa-file-text-o"></i>
						</b-link>
						<b-link @click.prevent="openPriceListModal(data.item)"
						>
							<i class="fa fa-print"></i>
						</b-link>
						<!-- <b-dropdown id="dropdown-dropright" dropright :text="$t('actions.title')" variant="primary"
									size="sm" no-caret class="myButton">
							<template slot="button-content"> &nbsp;{{ $t('actions.title')}} <i
								class="fa fa-caret-down"></i></template>
							<b-dropdown-item v-if="data.item.status == 'SUSPENDED'" href="#"
											 @click.prevent="editSuspendSale(data.item)"><i
								class="fa fa-edit editBtn"> {{ $t('wholesale.edit') }}</i>
							</b-dropdown-item>
							<b-dropdown-item @click.prevent="editBtn(data, 'forModal')"><i
								class="fa fa-eye editBtn"> {{ $t('wholesale.view') }}</i>
							</b-dropdown-item>
							<b-dropdown-item @click.prevent="editBtn(data, 'forDocument')"><i
								class="fa fa-file-text-o editBtn"> {{ $t('wholesale.document') }}</i>
							</b-dropdown-item>
							<b-dropdown-item @click.prevent="editBtn(data, 'forGridView')"><i
								class="fa fa-file-text editBtn">GridView</i>
							</b-dropdown-item>
							<b-dropdown-item @click.prevent="openPriceListModal(data.item.saleItems)"><i class="fa fa-print"> {{ $t('price_list')}}</i>
							</b-dropdown-item>
						</b-dropdown> -->
					</template>
				</b-table>
				<div v-if="getTableItems">
					<download-excel
						size="sm"
						class="btn btn-success"
						:data="itemsForExcel"
						worksheet="My Worksheet"
						name="Excel">
					</download-excel>
					<br>
					<br>
				</div>
				<nav>
					<div v-if="selected=='sales'">
						<b-pagination
							size="sm"
							:total-rows="lastFilterData.lastTotal ? lastFilterData.lastTotal : getSales.total"
							:per-page="perPage"
							v-model="currentPage"
							prev-text="Prev"
							next-text="Next"
							hide-goto-end-buttons
						/>
					</div>
					<div v-if="selected=='zReports'">
						<b-pagination
							size="sm"
							:total-rows="zReportsTotal"
							:per-page="perPage"
							v-model="currentPage"
							prev-text="Prev"
							next-text="Next"
							hide-goto-end-buttons
						/>
					</div>

				</nav>

				<div v-if="loader" class="spinner-wrapper">
					<b-spinner variant="primary"></b-spinner>
				</div>
			</div>
			<!--<div v-if="loader" class="spinner-wrapper">-->
			<!--<b-spinner variant="primary"></b-spinner>-->
			<!--</div>-->

		</b-card>
		<!-- CHECK TO PRINT BEGIN -->
		<div class="print section-to-print" v-if="!priceListStatus" id="posCheckClone">
			<div id="depNameClone" class="d-flex justify-content-center"><strong>DUTY-FREE - {{ shopName }}</strong>
			</div>
			<div id="depAddressClone" class="d-flex justify-content-center bottom-bordered"><i>{{ shopAddress }}</i>
			</div>
			<div class="d-flex justify-content-between"><span>{{ dateTime }}</span> <span style="text-align: right;">{{$t('sidebar.pos.check')}}: {{ currentSuspendId ? currentSaleSuspendNumber : currentSaleNumber
				}}</span>
			</div>
			<!--<div class="d-flex justify-content-between">-->
			<!--&lt;!&ndash;<span>{{$t('xAtchot.cashier')}}:{{ cashierFullName }}</span> &ndash;&gt;-->
			<!--&lt;!&ndash;<span&ndash;&gt;-->
			<!--&lt;!&ndash;style="text-align: right;">POS №:{{ cashboxNumber }}</span>&ndash;&gt;-->
			<!--</div>-->
			<div class="d-flex justify-content-between"
				 :class="returnItemsCount == 0 ? 'bottom-bordered' : ''"
			>
				<!--<span>{{$t('pos.saller')}}:{{ currentSellerName }}</span>-->
				<span style="text-align: right;">{{$t('pos.items')}}:{{ totalCount }}</span></div>
			<div
				v-if="returnItemsCount !== 0"
				class="d-flex justify-content-end bottom-bordered">
				<span style="text-align: right;">Возврат кол-во:{{ returnItemsCount }}</span>
			</div>
			<div class="posCheckTable bottom-bordered">

				<table>
					<thead>
					<tr>
						<th class="alignedLeft" style="width: 50%; word-break: break-all;">{{$t('sale.products')}}</th>
						<th class="alignedCenter" style="width: 17%; word-break: break-all;">{{$t('sale.kol-vo')}}</th>
						<th class="alignedCenter" style="width: 5%;">{{$t('promo-to-product.promo')}}</th>

						<th class="alignedRight" style="width: 32%; word-break: break-all;">
							{{$t('incomes.create.price')}}
						</th>
					</tr>
					</thead>
					<tbody>
					<tr
						v-for="(item, index) in getCartItems"
						:key="'checkItem' + index"
						:class="item.count < 0 ? 'returnItemBordered' : ''"
					>
						<td class="alignedLeft" style="width: 50%; word-break: break-all;">
							<strong>{{ index + 1 }}.</strong>{{ item.name }}/<strong>{{item.artikul}}</strong>/{{item.genderName
							}}/{{
							item.colorName }}/<strong>{{ item.size }}</strong>
						</td>
						<td class="alignedCenter" style="width: 17%; word-break: break-all;">
							{{ item.count > 0 ? item.count : -item.count }}
						</td>
						<td class="alignedCenter" style="width: 17%; word-break: break-all;">
							{{ promotionforPrint(item) }}
						</td>

						<td class="alignedRight" style="width: 32%; word-break: break-all;">
							{{ item.discountPriceUzs * item.count | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ''
							})}}
						</td>
					</tr>
					</tbody>
				</table>
			</div>
			<div class="posCheckTotal bottom-bordered">
				<table>
					<tbody>
					<tr>
						<td class="alignedLeft">{{$t('warehouse.table.totalIncomeUzs')}}</td>
						<td class="alignedRight">{{ finalTotalSum | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ''
							}) }}
						</td>
					</tr>

					<tr>
						<td class="alignedLeft">{{$t('pos.ndc')}}</td>
						<td class="alignedRight">{{ finalTotalSum/6 | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ''
							}) }}
						</td>
					</tr>
					<tr>
						<td class="alignedLeft">{{$t('xAtchot.pay')}}</td>
						<td class="alignedRight">{{ finalTotalSum | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ''
							}) }}
						</td>
					</tr>
					<!--<tr>-->
					<!--<td class="alignedLeft">{{$t('sale.payed')}}</td>-->
					<!--<td class="alignedRight">{{ totalPaid | currency({-->
					<!--symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',-->
					<!--thousandsSeparator: ''-->
					<!--}) }}-->
					<!--</td>-->
					<!--</tr>-->
					<tr v-if="returnItemsSum !== 0" class="returnItemBordered">
						<td class="alignedLeft">{{$t('pos.return')}}</td>
						<td class="alignedRight">{{ -returnItemsSum | currency({
							symbol: userDepCurrencyName, fractionCount: 2,
							symbolPosition:
							'back', thousandsSeparator: ''
							}) }}
						</td>
					</tr>
					<tr v-if="parseInt(sponsorshipAmount) > 0" class="returnItemBordered">
						<td class="alignedLeft">{{$t('sidebar.sales.sponsor')}}</td>
						<td class="alignedRight">{{ sponsorshipAmount | currency({symbol: userDepCurrencyName,
							fractionCount: 2,
							symbolPosition:
							'back', thousandsSeparator: ''}) }}
						</td>
					</tr>
					<tr v-if="parseInt(debtPayment) > 0">
						<td class="alignedLeft">{{$t('xAtchot.debt')}}</td>
						<td class="alignedRight">{{ debtPayment | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ''
							}) }}
						</td>
					</tr>
					<!--<tr>-->
					<!--<td class="alignedLeft">{{$t('promo-to-product.promo')}}</td>-->
					<!--<td class="alignedRight" v-if="customPromotion">-->
					<!--{{ customPromotion.discount }}-->
					<!--<span v-if="customPromotion.promotionType == '%'">{{ customPromotion.promotionType }}</span>-->
					<!--<span v-else>{{ userDepCurrencyName }}</span>-->
					<!--</td>-->
					<!--<td class="alignedRight" v-else>{{ 0 | currency({-->
					<!--symbol: '',-->
					<!--symbolPosition: 'back', thousandsSeparator: ''-->
					<!--}) }}-->
					<!--</td>-->
					<!--</tr>-->
					</tbody>
				</table>
			</div>
			<div class="posThanks">
				<!--<p><i>&#45;&#45; Xaridingiz uchun raxmat! &#45;&#45;      Davlat tili rus tili deb elon qilyapmizuuuuuu  ))))))))</i></p>-->
				<p><i>-- {{$t('pos.please')}}! --</i></p>
			</div>
		</div>
		<div class="print section-to-print" v-else>
			<div class="generalTableClass mt-3 ml-2">
				<table class="table b-table table-striped table-hover table-bordered">
					<thead>
					<tr>
						<th>ID</th>
						<th>{{ $t('goods.artikul')}}</th>
						<th>{{ $t('goods.color')}}</th>
						<th>{{ $t('goods.name')}}</th>
						<th>{{ $t('incomes.create.count')}}</th>
						<th>{{ $t('prices.item.lastPriceWholesale')}}</th>
						<th>{{ $t('prices.item.lastPriceUzs')}}</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="item,index in priceListItemsGET.items">
						<td class="text-center">{{index + 1}}</td>
						<td class="text-center">{{item.artikul}}</td>
						<td class="text-center">{{item.color}}</td>
						<td class="text-center">{{item.name.substr(0,30)}}</td>
						<td class="text-center">{{item.count}}</td>
						<td class="text-center">{{item.priceWholesale | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
							})}}</td>
						<td class="text-center">{{item.priceUzs | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
							})}}</td>

					</tr>
					</tbody>
					<tfoot>
					<tr>
						<td class="text-right" colspan="4"><b>TOTAL: &nbsp;</b> </td>
						<th> {{ totalCountPriceList() }}</th>
						<th class="text-center">{{priceListItemsGET.totalPriceWholeSale | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
							})}}</th>
						<th class="text-center">{{priceListItemsGET.totalPriceUzs | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
							})}}</th>
					</tr>
					</tfoot>
				</table>
			</div>
		</div>
		<!-- CHECK TO PRINT END -->
		<b-modal id="saleViewModal"
					ref="saleViewModal"
				 size="xl"
				 hide-footer
		>
			<sale-view :item="item" :currencyForSaleView="currencyForSaleView" v-if="isSales"></sale-view>
			<z-report-view :zReport="zReportGetById" :currencyForZReportView="currencyForZReportView" v-else
						   @close="closeModalZReport"></z-report-view>
		</b-modal>
		<b-modal
			class="hidden-print"
			v-model="showPriceList"
			size="lg"
			hide-footer
			:no-close-on-esc="true"
			:no-close-on-backdrop="true"
		>
			<template slot="modal-header" class="addItemsModalHeader">
				<button
					type="button"
					class="close right"
					data-dismiss="modal"
					aria-label="Close"
					@click="closePriceListModal"
				>
					<i class="fa fa-times sm"></i>
				</button>
			</template>

			<div>

				<table class="table b-table table-striped table-hover table-bordered" id="tbssslData">
					<thead>
					<tr>
						<th>ID</th>
						<th>{{ $t('goods.artikul')}}</th>
						<th>{{ $t('goods.color')}}</th>
						<th>{{ $t('goods.name')}}</th>
						<th>{{ $t('incomes.create.count')}}</th>
						<th>{{ $t('prices.item.lastPriceWholesale')}}</th>
						<th>{{ $t('prices.item.lastPriceUzs')}}</th>
					</tr>
					</thead>
					<tbody>
						<!-- //usi jer -->
					<tr v-for="item,index in priceListItemsGET.items">
						<td>{{index + 1}}</td>
						<td>{{item.artikul}}</td>
						<td>{{item.color}}</td>
						<td>{{item.name.substr(0,30)}}</td>
						<td class="text-center">{{item.count}}</td>
						<td class="text-center">{{item.priceWholesale | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
							})}}
						</td>
						<td class="text-center">{{item.priceUzs | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
							})}}
						</td>

					</tr>
					</tbody>
					<tfoot>
					<tr>
						<td class="text-right" colspan="4"><b>TOTAL: &nbsp;</b></td>
						<th class="text-center">{{ totalCountPriceList() }}</th>
						<th class="text-center">{{priceListItemsGET.totalPriceWholeSale | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
							})}}
						</th>
						<th class="text-center">{{priceListItemsGET.totalPriceUzs | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
							})}}
						</th>
					</tr>
					</tfoot>
				</table>
				<hr>

				<div class="row top mt-3 justify-content-end">
					<div class="col-3">
						<b-button variant="outline-danger" size="sm" block
								  @click="closePriceListModal">
							{{$t('actions.cancel')}}
						</b-button>
					</div>
					<div class="col-3">
						<b-button variant="outline-success" size="sm" block @click="print('tbssslData')">
							{{$t('Excel')}}
						</b-button>
					</div>
					<div class="col-3">
<!--						<b-button variant="outline-success" size="sm" block @click="printPdf">-->
<!--							{{$t('PDF')}}-->
<!--						</b-button>-->
					</div>
				</div>
			</div>
		</b-modal>

		<b-modal id="paymentModal"
				 v-model="paymentModal"
				 size="md"
				 hide-footer
		>
			<payment
				:item="currentObjectToPayment"
				@close="closePaymentModal"
			>
			</payment>
		</b-modal>

		<vs-sidebar
			position-right
			parent="body"
			default-index="1"
			color="primary"
			class="create-modal priceSidebar"
			spacer
			v-model="activeSidebar"
			:click-not-close="true"
		>
			<RefundEdit :item="item" @closeSidebar="closeSidebar" @updateSaleRefound="updateSaleRefound"></RefundEdit>
		</vs-sidebar>
		<vs-sidebar :click-not-close="true"
					position-right
					parent="body"
					default-index="1"
					color="primary"
					class="create-modal-wholesale"
					spacer
					v-model="sidebar.open">
			<b-container index="1" v-if="sidebar.open">
				<!--<create-form
					@close="close()"
					:mode="sidebar.mode"
					:edit-item="editItem"
					@redirect=""
					@docSuspended="changed(1, $event)"
				></create-form>-->
				<pos
					@close="close()"
					@closeWithDoc="close($event,'withDoc')"
					:mode="sidebar.mode"
				></pos>
			</b-container>
		</vs-sidebar>
	</div>
</template>

<script>
	import {mapActions, mapGetters, mapState} from "vuex";
	import MaskedInput from 'vue-masked-input'
	import Multiselect from 'vue-multiselect'
	import RefundEdit from './SaleEdit'
	import SaleView from './SaleView'
	import ZReportView from './zReportView'
	import CreateForm from "./blocksWholesale/CreateForm";
	import Pos from "./WholesalePos";
	import {TokenService} from "../../../services/storage.service";
	import Payment from "./pages/payment";
import PosService from '../../../services/pos.service';

	export default {
		name: 'wh',
		components: {
			MaskedInput,
			Multiselect,
			RefundEdit,
			SaleView,
			ZReportView,
			CreateForm,
			Pos,
			Payment
		},
		data() {
			return {
				departmentSaleType: TokenService.getDepSaleType() ? TokenService.getDepSaleType() :  ' ',
				fromPageName: '',
				dateTime: '',
				cashboxNumber: localStorage.getItem('cash_number'),
				paymentModal: false,
				currentObjectToPayment: {
					amount: 0,
					whole: 0,
				},
				debtPayment: 0,
				returnMoney: 0,
				returnItemsCount: 0,
				returnItemsSum: 0,
				sponsorshipAmount: 0,
				editItem: null,
				sidebar: {
					open: false,
					close: false,
					mode: 'create'
				},
				loader: false,
				items: [],
				activeEditSidebar: false,
				currentPage: TokenService.getLastCurrentPage() ? TokenService.getLastCurrentPage() : 1,
				zReportGetById: {},
				perPage: 10,
				fromDate: "",
				toDate: "",
				isDropped: false,
				popoverShow: false,
				selectedDepartment: [],
				zReportDep: null,
				saleNumber: '',
				activeSidebar: false,
				item: [],
				currencyForSaleView: '',
				currencyForZReportView: '',
				currentZReport: {},
				contrAgent: [],
				checkStatus: null,
				selected: 'sales',
				options: [
					{text: 'Продажи', value: 'sales'},
					{text: 'Z отчеты', value: 'zReports'}
				],
				showPriceList: false,
			}
		},
		watch: {
			isFromSaleDocPage: {
				async handler(newValue) {
					if (newValue) {
						this.selectedDepartment = this.lastSelectedDeps;
						// this.currentPage = this.lastCurrentPage;
						this.checkStatus = this.lastFilterData.status;
						this.toDate = this.lastFilterData.toDate;
						this.fromDate = this.lastFilterData.fromDate;
						this.contrAgent = this.lastFilterData.selectedContragents;
						this.saleNumber = this.lastFilterData.saleNumber;
						if (this.getSales.items && this.getSales.items.length == 0) {
							await this.search();
						}
						await this.$store.commit('wholesalePos/setIsFromSaleDocPage', false);
					} else {
						let filterPayloadToSave = {
							fromDate: '',
							toDate: '',
							saleNumber: '',
							selectedContragents: [],
							status: null,
							selectedDepartment: [],
							currentPage: 1,
							lastTotal: null
						}
						await this.saveSelectedDeps(filterPayloadToSave);
						await TokenService.setLastCurrentPage(null);
					}
				}
			},
			currentPage: {
				async handler(newValue, oldValue) {
					if (this.selected == 'sales') {
						if (this.isFromSaleDocPage) {
							if (newValue == this.lastCurrentPage) {
								await this.search()
							}
							await this.$store.commit('wholesalePos/setIsFromSaleDocPage', false);
						} else {
							await this.search();
						}
					}
					if (this.selected == 'zReports') {
						this.search();
					}
				}
			}
		},
		methods: {
			...mapActions('wholesalePos', [
				'setDefaultPriceListItems', 'getPriceListItems', 'getPriceListItemsSale' ,'getSaleById'
			]),
			calculatePaidSum(payments) {
				let paidSum = 0;
				payments.forEach(el => {
					if (el.paymentTypeCode !== 'QARZGA') {
						paidSum += el.value;
					}
				})
				return paidSum;
			},
			hasDeptPayment(payments){
				let foundIndex = payments.findIndex(payment => payment.paymentTypeCode == 'QARZGA');
				if (foundIndex > -1) {
					return true;
				}
				return false;
			},
			getamountOfSumma(el) {
				return el.amountOfPaymentUzs.toFixed(2) + " " + this.returnCurrencyNameForDep(el.payments.length > 0 ? el.payments[0].paymentTypeId : {})
			},
			getamountOfDiscountSumma(el) {
				return el.amountOfAfterPromoUzs.toFixed(2)  + " " + this.returnCurrencyNameForDep(el.payments.length > 0 ? el.payments[0].paymentTypeId : {})
			},
			getPaymentStatus(el) {
				if (el.payments) {
					for(let i=0; i<el.payments.length; i++) {
						if(el.payments[i].paymentTypeCode == "QARZGA" && el.payments.length >=1) {
							return this.$t('xAtchot.debt') + " " +  el.payments[i].value +
							" " + this.returnCurrencyNameForDep(el.payments[i].paymentTypeId)
						}
						if(el.payments.length <= 1 &&
							el.payments[i].paymentTypeCode != "QARZGA" &&
							el.payments[i].paymentTypeCode != "HOMIYLIK"
						) {
							return this.$t('sidebar.sales.ready')
						}
					}
				}
			},
			promotionforPrint(item) {
				let promoparam;
				if (item.promotions) {
					for (let i = 0; i < item.promotions.length; i++) {
						if (item.promotions[i].type == "%" && item.promotions[i].value > 0) {
							promoparam = item.promotions[i].value + '%'
						}
						if (item.promotions[i].type == "PUL" && item.promotions[i].value > 0) {
							promoparam = item.promotions[i].value
						}

					}
					return promoparam;
				}

			},
			async closePriceListModal() {
				await this.setDefaultPriceListItems(false);
				this.showPriceList = false;
			},

			printPdf(){
				window.print();
			},
			async print(table, filename = '') {

				var uri = 'data:application/vnd.ms-excel;base64,',
					template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
					, base64 = await function (s) {
						return window.btoa(unescape(encodeURIComponent(s)))
					}
					, format = await function (s, c) {
						return s.replace(/{(\w+)}/g, function (m, p) {
							return c[p];
						})
					};
				if (!table.nodeType) table = document.getElementById(table);
				var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML};
				window.location.href = uri + base64(format(template, ctx));
			},
			totalCountPriceList(){
				// let count = 0;
				// if(this.priceListItems.items){
				// 	this.priceListItems.items.forEach(item => {
				// 		count += parseInt(item.count)
				// 	});
				// }
				// return count;
			},
			async openPriceListModal(allItems) {
				await this.getPriceListItemsSale(allItems.id);
				this.showPriceList = true;
			},
			closePaymentModal() {
				this.paymentModal = false;
			},
			makeCurrentDateTime() {
				let now = new Date();
				let year = now.getFullYear();
				let month = now.getMonth() + 1;
				let day = now.getDate();
				let hour = now.getHours();
				let minute = now.getMinutes();
				let second = now.getSeconds();
				if (month.toString().length == 1) {
					month = '0' + month;
				}
				if (day.toString().length == 1) {
					day = '0' + day;
				}
				if (hour.toString().length == 1) {
					hour = '0' + hour;
				}
				if (minute.toString().length == 1) {
					minute = '0' + minute;
				}
				if (second.toString().length == 1) {
					second = '0' + second;
				}
				this.dateTime = year + '/' + month + '/' + day + ' ' + hour + ':' + minute + ':' + second;
			},
			async editSuspendSale(sale) {
				await this.editForPosDraft(sale);
				this.sidebar.mode = 'edit';
				this.sidebar.open = true;
//				this.clientName = data.customerName;
//				this.$store.commit('clients/resetCurrentClient');
				// Fire.$emit('activeEmit', {suspendActive: true, message: "Bu edit uchun"});
				/*await this.$emit('changeSuspendActive', true);
                await this.$emit('searchBarFocus');*/
			},
			close(saleId, str) {
				// WhDocument.clearWhDocument(); //BU API O'ZGARDI
				this.sidebar.open = false;
				/*let vm = this;
				setTimeout(function () {
                    if(str == 'withDoc') {
                        vm.$router.push(`/warehouse-management/wholesale/view/${saleId}`);
                    }
                }, 50);*/

				this.sidebar.mode = 'create';
				this.editItem = {};
			},
			openCreate(mode = 'create') {
				this.sidebar.mode = mode;
				this.sidebar.open = true;
			},
			returnCurrencyNameForDep(sale) {
				if (sale.currencyName) {
					return sale.currencyName
				} else if (this.getDepartments.length > 0) {
					let tempForDep = this.getDepartments.find(dep => {
						return dep.id == sale.shopId;
					});
					if (tempForDep) {
						return tempForDep.currencyName;
					} else {
						return this.userDepCurrencyName
					}
				} else {
					return this.userDepCurrencyName
				}
			},
			closeModalZReport(boolean) {
				if (boolean) {
					// this.$refs.zReportView.hide();
				}
			},
			...mapActions('pos', [
				'editForPosDraft'
			]),
			...mapActions('refunds', [
				'getSaleLists', 'getZreportsList',
				'getItemsFromId', 'setRefound',
				'getOptomSaleLists', 'saveSelectedDeps',
				'fetchWholeReturnSales'
			]),
			...mapActions('prices', [
				'getDepartmentList'
			]),
			...mapActions('contragents', ['fetchContragents']),
			async search() {
				if (this.selected == 'sales') {
					if (this.selectedDepartment.length > 0) {
						this.loader = true;
						this.isDropped = true;
						const departments = this.selectedDepartment.map((department) => {
							return department.id
						});
						const contrAgentList = this.contrAgent.map((contragent) => {
							return contragent.id
						});
						let data = {
							page: this.currentPage,
							limit: this.perPage,
							startDate: this.fromDate,
							endDate: this.toDate,
							saleNumber: this.saleNumber,
							status: this.checkStatus,
							department: departments,
							contragent: contrAgentList,
						}
						// IF RETURN STATUS IS SELECTED
						if (this.checkStatus == 'QAYTARISH') {
							await this.fetchWholeReturnSales(data);
						} else {
							await this.getOptomSaleLists(data);
						}
						this.loader = false;
					} else {
						this.$vs.notify({
							text: "Выберите Подразделение",
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
						return 0;
					}
				} else {
					if (this.zReportDep) {
						if (this.fromDate == '') {
							this.fromDate = null;
						}
						if (this.toDate == '') {
							this.toDate = null;
						}
						await this.getZreportsList(
							{
								departmentId: this.zReportDep.id,
								startDate: this.fromDate,
								endDate: this.toDate,
								page: this.currentPage,
								limit: 20
							}
						);
					} else {
						this.$vs.notify({
							text: "Выберите Подразделение",
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
						return 0;
					}
				}
			},

			saleItemsCount(saleItems) {
				let count = 0;
				if (saleItems) {
					if (saleItems.length > 0) {
						saleItems.forEach(sale => {
							count += sale.count;
						})
					}
				}
				return count;
			},

			showEditPopover() {
				this.popoverShow = true
			},
			getDepartmentsLocal() {
				return this.getDepartments
			},
			openSearchForm() {
				this.isDropped = !this.isDropped
			},
			closeEditSidebar() {
				this.activeEditSidebar = false
			},
			async editBtn(data, forText = 'refund') {
				//this.$refs['popover-'+data.index].$emit('close')
				if (forText == 'forDocument') {
					let filterPayloadToSave = {
						fromDate: this.fromDate,
						toDate: this.toDate,
						saleNumber: this.saleNumber,
						selectedContragents: this.contrAgent,
						status: this.checkStatus,
						selectedDepartment: this.selectedDepartment,
						currentPage: this.currentPage,
						lastTotal: this.getSales.total
					}
					await TokenService.setLastCurrentPage(this.currentPage);
					await this.saveSelectedDeps(filterPayloadToSave);
					if(data.item.romaniaOrMoldova == 'ROMANIYA') {
						await this.$router.push(`/warehouse-management/wholesale/view/${data.item.id}/romaniya`);
					}
					if(data.item.romaniaOrMoldova == 'MOLDOVA') {
						await this.$router.push(`/warehouse-management/wholesale/view/${data.item.id}`);
					}
				}
				// else if (forText == 'forGridView') {
				// 	let filterPayloadToSave = {
				// 		selectedDepartment: this.selectedDepartment,
				// 		currentPage: this.currentPage
				// 	}
				// 	await this.saveSelectedDeps(filterPayloadToSave);
				// 	await this.$router.push(`/warehouse-management/wholesale/grid-view/${data.item.id}`);
				// }
				this.currencyForSaleView = this.returnCurrencyNameForDep(data.item);
				this.item = data.item;
				if (forText !== 'forModal' && forText !== 'forDocument') {
					// this.activeSidebar = true
				}
				if(forText == 'forModal') {
					if (this.checkStatus == 'QAYTARISH') {
						await this.getSaleById(data.item.id);
						this.item = this.saleForDocument;
					}
					await this.$refs.saleViewModal.show()
				}
				this.popoverShow = false
			},
			async updateSaleRefound(obj) {
				this.activeSidebar = false
				await this.setRefound(obj)
				let data = {
					page: this.currentPage,
					limit: this.perPage
				}
				await this.getSaleLists(data)
			},
			closeSidebar() {
				this.activeSidebar = false
			}
		},
		computed: {
			itemsForExcel() {
				if(this.getTableItems) {
					let array = []
					let temp;
					this.getTableItems.forEach(el => {
						temp = Object.assign({},
							{
								"Номер чека" : el.saleNumber,
								"Дата продажи": el.saleDate,
								"Отдел": el.shopName,
								"Статус" : this.getPaymentStatus(el),
								"Кол-во товаров": el.saleItems ? el.saleItems.length : el.totalCount,
								"Сумма": this.getamountOfSumma(el),
								"Сумма со скидкой": this.getamountOfDiscountSumma(el),
								"Комментарии": el.comment,
							}
						);
						array.push(temp)
					})
						return array
				}
			},
			saleCurrencyName() {
				if (this.refCurrencies.length > 0 && this.saleCurrency && this.isCurrenciesDifferent) {
					let temp = this.refCurrencies.find(el => el.id == this.saleCurrency);
					return temp ? temp.name : '';
				} else {
					return this.userDepCurrencyName;
				}
			},
			...mapGetters('refunds', [
				'getSales',
				'getStatus'
			]),
			...mapGetters('wholesalePos', [
				'getItems', 'getCartItems', 'getDiscountItemForModal'
			]),
			...mapGetters('prices', [
				'getDepartments',
			]),
			...mapState('refunds', ['zReports', 'zReportsTotal',
				'lastSelectedDeps', 'lastCurrentPage', 'lastFilterData'
			]),
			...mapState(['isCashier', 'userDepCurrencyName']),

			...mapState('contragents', ['contragents']),
			...mapState('wholesalePos', [
				'totalCount', 'totalSum', 'checkPage', 'finalTotalSum', 'realTotalSum', 'comment', 'checkForWholeSale',
				'shopName', 'currentSaleNumber',
				'currentSaleId',
				'shopAddress', 'cashierFullName', 'currentSellerName', 'sellerId',
				'currentSuspendId', 'currentSaleSuspendNumber', 'lastSuspendedSaleNumber', 'saleItemForDiscountModal', 'discount', 'customPromotion', 'errorOccur',
				'searchLoading', 'saleFinishError', 'saleFinishLoading',
				'isReturn', 'convertError', 'withDocumentStore','priceListItems', 'priceListItemsGET' ,'priceListStatus', 'saleForDocument',
				'isFromSaleDocPage'
			]),
			salesFields() {
				return [
					{
						key: 'id',
						label: this.$t('users-l.Id'),
						'class': 'role_id',
						sortable: true
					},
					{
						key: 'saleNumber',
						label: this.$t('sale.saleNumber'),
						sortable: true
					},
					{
						key: 'saleDate',
						label: this.$t('sale.saleDate'),
						sortable: true
					},
					{
						key: 'shopName',
						label: this.$t('sale.shopName'),
						sortable: true
					},
					{
						key: 'status',
						label: this.$t('sale.status'),
						sortable: true
					},
					{
						key: 'itemsCount',
						label: 'Кол-во товаров',
						sortable: true,
						'class': 'textAlignCenter'
					},
					{
						key: 'amountOfPaymentUzs',
						label: 'Сумма',
						sortable: true,
						'class': 'textAlignCenter'
					},
					{
						key: 'amountOfAfterPromoUzs',
						label: 'Сумма со скидкой',
						sortable: true,
						'class': 'textAlignCenter'
					},
					{
						key: 'contragentName',
						label: this.$t('sale.contragent'),
						sortable: true
					},
					/*{
						key: 'customerName',
						label: this.$t('sale.client'),
						sortable: true
					},*/
					{
						key: 'actions',
						'class': 'table_actions min-60',
						label: this.$t('actions.title')
					}
				]
			},
			zReportsFields() {
				return [
					{
						key: 'id',
						label: 'ID',
						'class': 'role_id',
						sortable: true
					},
					{
						key: 'startDate',
						label: 'Дата начала',
						sortable: true
					},
					{
						key: 'endDate',
						label: 'Дата окончания',
						sortable: true
					},
					{
						key: 'companyDepartmentName',
						label: this.$t('sale.shopName'),
						sortable: true
					},
					{
						key: 'zReportStatus',
						label: 'Статус',
						sortable: true,
						'class': 'textAlignCenter'
					},
					{
						key: 'actions',
						'class': 'table_actions min-60',
						label: this.$t('actions.title')
					}
				]
			},
			isSales() {
				return this.selected == 'sales';
			},
			getTableItems() {
				return this.isSales ? this.getSales.items : this.zReports;
			},
			computedFields() {
				return this.isSales ? this.salesFields : this.zReportsFields;
			},
		},
		beforeRouteLeave(to, from, next) {
			if (this.sidebar.open) {
				this.close()
				next(from.path)
			} else {
				next()
			}
		},
		beforeRouteEnter(to, from, next) {
			next(vm => {
				if (from.matched[0]) {
					if (from.matched[0].name == 'NakladnoyWholesale') {
						vm.$store.commit('wholesalePos/setIsFromSaleDocPage', true);
					} else {
						vm.$store.commit('wholesalePos/setIsFromSaleDocPage', false);
					}
				} else {
					vm.$store.commit('wholesalePos/setIsFromSaleDocPage', false);
				}
				next();
			})
		},
		async created() {
			await this.$store.commit('contragents/setContragentName',null)
			this.makeCurrentDateTime('savePos');
			await this.getDepartmentList()
			await this.getDepartmentsLocal()
			await this.fetchContragents()
			this.activeSidebar = false
		},
		destroyed() {
			this.$store.commit('wholesalePos/setIsFromSaleDocPage', false);
			// this.$store.commit('refunds/resetSales', []);
			this.$store.commit('refunds/resetZReports');
		}
	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
	// @import url('https://fonts.googleapis.com/css?family=Inconsolata');


	.container {
		padding: 0;
	}

	// @import url('https://fonts.googleapis.com/css?family=Inconsolata');

	.print {
		display: none;
	}

	@media print {
		.hidden-print {
			display: none;
		}
		.print {
			display: block;
		}
		.card {
			box-shadow: none;
		}
	}

	.posCustomModalHeader {
		display: flex;
		width: 100%;
		justify-content: space-between;

		.close {
			font-size: 14px;
		}
	}

	p {
		margin-bottom: 0;
	}
	.create-modal-wh .vs-sidebar {
		max-width: 93% !important;
	}
	.editBtn {
		font-size: 14px;
		cursor: pointer;
	}

	.filter-frame {
		padding-bottom: 15px;
	}

	.slide-enter, .slide-leave-to {
		transform: scaleY(0);
	}

	.certificateGenerate {
		background: transparent !important;
		border: none;
		padding: 7px;
		font-size: 16px;
	}

	.certificateGenerate span {
		margin-left: 5px;
	}

	.top-card {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.search_btn {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		padding-right: 25px
	}

	input[type=number]::-webkit-inner-spin-button,
	input[type=number]::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	.btn-sml {
		padding: 4px 4px;
		font-size: 9px;
		border-radius: 6px;
	}

	.dropdown-menu {
		font-size: 1px !important;
	}

	.dropdown-item i {
		color: black;
	}

	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 35px;
		z-index: 5;
	}

	.table-wrapper {
		position: relative;
		padding: 5px;
	}
	.mx-datepicker{
		width: 290px;
		padding-left: 0;
	}
	#posCheckClone {
		width: 70mm;
		background: white;
		padding: 10px;
		font-family: monospace;
		font-size: 13px;
		font-weight: 500;
		color: #000000 !important;

		#depNameClone {
			font-size: 18px;
		}

		.bottom-bordered {
			padding-bottom: 2px;
			border-bottom: .5px dashed #444;
		}

		table {
			width: 100%;
		}

		.returnItemBordered {
			border: .5px dotted black;
		}

		td, th {
			border: none;
			font-size: 11px;
			padding: 2px;
			color: #000000;
			vertical-align: top !important;
		}

		.table {
			td, th {
				vertical-align: top;
			}
		}

		.posCheckTotal {
			table {
				td {
					font-weight: bold;
					font-size: 13px;
				}
			}
		}

		.posThanks {
			p {
				text-align: center;
				font-weight: bold;
				font-size: 13px;
			}
		}
	}
</style>
